import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { History } from "lucide-react";
import { formatPrice, resolveImage } from "@/lib/api";
import { getRecentlyViewed } from "@/lib/recentlyViewed";

export default function RecentlyViewed() {
  const { pathname } = useLocation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    const refresh = () => setItems(getRecentlyViewed());
    refresh();
    window.addEventListener("recentlyViewedChange", refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener("recentlyViewedChange", refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  // Ne pas afficher dans l'admin
  if (pathname.startsWith("/admin")) return null;

  // Exclure le produit actuellement affiché
  const currentId = pathname.startsWith("/produit/") ? decodeURIComponent(pathname.split("/produit/")[1] || "") : null;
  const list = items.filter((p) => p.product_id !== currentId);

  if (list.length === 0) return null;

  return (
    <section data-testid="recently-viewed" className="border-t border-amber-900/10 bg-sand/40">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-8">
        <h2 className="mb-5 flex items-center gap-2 font-serif text-xl font-semibold text-bark">
          <History size={18} className="text-honey" /> Déjà consultés
        </h2>
        <div className="flex gap-4 overflow-x-auto pb-2">
          {list.map((p) => (
            <Link
              key={p.product_id}
              to={`/produit/${p.product_id}`}
              data-testid={`recently-viewed-${p.product_id}`}
              className="group flex w-40 shrink-0 flex-col overflow-hidden rounded-2xl border border-amber-800/15 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="aspect-[4/3] overflow-hidden bg-white">
                <img
                  src={resolveImage(p.image_url)}
                  alt={p.name}
                  loading="lazy"
                  className="h-full w-full object-contain p-2 transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col gap-1 p-3">
                <p className="line-clamp-2 min-h-[2.5rem] text-sm font-medium leading-snug text-bark">{p.name}</p>
                <p className="mt-auto font-serif text-base font-semibold text-amber-deep">{formatPrice(p.price_cents)}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
